import { render, staticRenderFns } from "./DynamicFAQ.vue?vue&type=template&id=660e1468&"
import script from "./DynamicFAQ.vue?vue&type=script&lang=js&"
export * from "./DynamicFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports